<template>
  <div class="discover-container">
    <h1 class="page-title">Discover</h1>
    <hr class="mb-0" />

    <div class="partners-wrapper">
      <p class="brands-title">Partners:</p>
      <div class="brands-wrapper">
        <BrandsDisplay />
      </div>
    </div>

    <NotificationCard v-if="showNotificationCard" />

    <div class="mb-5">
      <hr style="margin-bottom: -1px" />
      <DiscoverNav />
    </div>

    <div class="hello">
      <transition :name="$router.currentRoute.name">
        <keep-alive>
          <router-view></router-view>
        </keep-alive>
      </transition>
    </div>
  </div>
</template>

<script>
// UI Components
import BrandsDisplay from "@/components/brandsDisplay";
import CapsuleHomeWrapper from "@/components/capsule/CapsuleHomeWrapper";
import DiscoverNav from "@/components/discover/DiscoverNav";
import NotificationCard from "@/components/discover/NotificationCard";

// Other
import { mapGetters } from "vuex";

export default {
  components: {
    BrandsDisplay,
    CapsuleHomeWrapper,
    DiscoverNav,
    NotificationCard,
  },

  computed: {
    ...mapGetters(["currentUser"]),
    showNotificationCard() {
      return this.currentUser && this.currentUser.capsule_count < 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_colour-palette.scss";
// Modal
// ------------------------------
// TODO: This is required for modal - Seems to shrink width when removed even
// though DOM element is not in this file
.modal-lg {
  max-width: 80%;
}

.discover-container {
  .brands-title {
    letter-spacing: 1.4px;
    font-size: 12px;
    font-weight: 400;
    color: $grey3;
  }

  .partners-wrapper {
    margin-top: 26px;
    margin-bottom: 60px;
  }
}

$percentage: 40%;
// ---------------

.DiscoverOutfits-enter {
  opacity: 0;
  transform: translateX($percentage);
  position: initial;
}

.DiscoverOutfits-enter-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  position: initial;
}

.DiscoverOutfits-leave-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  transform: translateX(-$percentage);
  position: absolute;
}

// Backwards transition

.DiscoverCapsules-enter {
  opacity: 0;
  transform: translateX(-$percentage);
}

.DiscoverCapsules-enter-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.DiscoverCapsules-leave-active {
  transition: all 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  opacity: 0;
  transform: translateX($percentage);
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/pages/Discover.vue